import React from 'react';
import { API_URLS } from '../config/api';

/**
 * Page de test pour vérifier les variables d'environnement
 */
const TestEnv = () => {
  // Tester différentes façons d'accéder aux variables d'environnement
  const reactAppApiUrl = process.env.REACT_APP_API_URL;
  const nodeEnv = process.env.NODE_ENV;
  
  return (
    <div style={{ 
      padding: '40px', 
      fontFamily: 'monospace',
      backgroundColor: '#f5f5f5',
      minHeight: '100vh'
    }}>
      <h1 style={{ color: '#333', marginBottom: '30px' }}>🧪 Test Variables d'Environnement</h1>
      
      <div style={{ 
        backgroundColor: 'white', 
        padding: '20px', 
        borderRadius: '8px',
        marginBottom: '20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ color: '#666', fontSize: '18px', marginBottom: '15px' }}>
          📋 Variables process.env
        </h2>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>NODE_ENV:</td>
              <td style={{ padding: '10px', color: nodeEnv ? 'green' : 'red' }}>
                {nodeEnv || '❌ undefined'}
              </td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>REACT_APP_API_URL:</td>
              <td style={{ padding: '10px', color: reactAppApiUrl ? 'green' : 'red' }}>
                {reactAppApiUrl || '❌ undefined'}
              </td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>typeof process:</td>
              <td style={{ padding: '10px' }}>
                {typeof process}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style={{ 
        backgroundColor: 'white', 
        padding: '20px', 
        borderRadius: '8px',
        marginBottom: '20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ color: '#666', fontSize: '18px', marginBottom: '15px' }}>
          🔧 Configuration API actuelle (api.js)
        </h2>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>API_URLS.test:</td>
              <td style={{ padding: '10px', wordBreak: 'break-all' }}>
                {API_URLS.test}
              </td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>API_URLS.submit:</td>
              <td style={{ padding: '10px', wordBreak: 'break-all' }}>
                {API_URLS.submit}
              </td>
            </tr>
            <tr style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>API_URLS.ownerLeadSubmit:</td>
              <td style={{ padding: '10px', wordBreak: 'break-all' }}>
                {API_URLS.ownerLeadSubmit}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style={{ 
        backgroundColor: 'white', 
        padding: '20px', 
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ color: '#666', fontSize: '18px', marginBottom: '15px' }}>
          🎯 Diagnostic
        </h2>
        {API_URLS.ownerLeadSubmit.includes('localhost') ? (
          <div style={{ 
            padding: '15px', 
            backgroundColor: '#fee', 
            color: '#c00',
            borderRadius: '4px',
            marginBottom: '10px'
          }}>
            ❌ <strong>PROBLÈME DÉTECTÉ:</strong> L'API pointe vers localhost au lieu de https://locajoy.com
          </div>
        ) : (
          <div style={{ 
            padding: '15px', 
            backgroundColor: '#efe', 
            color: '#0a0',
            borderRadius: '4px',
            marginBottom: '10px'
          }}>
            ✅ <strong>OK:</strong> L'API pointe vers https://locajoy.com
          </div>
        )}

        {!reactAppApiUrl && (
          <div style={{ 
            padding: '15px', 
            backgroundColor: '#ffc', 
            color: '#880',
            borderRadius: '4px'
          }}>
            ⚠️ <strong>ATTENTION:</strong> process.env.REACT_APP_API_URL est undefined. 
            Le fallback 'http://localhost:5000' est utilisé dans api.js
          </div>
        )}
      </div>

      <div style={{ 
        marginTop: '20px',
        padding: '15px',
        backgroundColor: '#e3f2fd',
        borderRadius: '4px',
        fontSize: '14px'
      }}>
        <strong>💡 Comment tester:</strong>
        <ol style={{ marginTop: '10px', paddingLeft: '20px' }}>
          <li>Accédez à cette page: <code>https://locajoy.com/test-env</code></li>
          <li>Vérifiez que REACT_APP_API_URL contient "https://locajoy.com"</li>
          <li>Vérifiez que les URL API pointent vers https://locajoy.com</li>
          <li>Si tout est en rouge, le problème vient du build React</li>
        </ol>
      </div>
    </div>
  );
};

export default TestEnv;
